export type { TimelineProps } from './TimelineGeneric';
export { default } from './TimelineGeneric';
